import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { deepExtract } from 'helpers/deep';
import { CORPORATE_JUSTWORKS_REGEX, CORPORATE_PLAN_REGEX } from 'constants/corporate';
import { COMEMBERSHIP, ALLOW_PREPAID_CARDS_PLANS } from 'constants/plan-types';
import { COSTCO_PLAN_IDS } from 'constants/costcoPlanIds';
var CLUB_CLASSES_NUMBERS = [0, 1];

var PlanDeriver =
/*#__PURE__*/
function () {
  function PlanDeriver() {
    _classCallCheck(this, PlanDeriver);
  }

  _createClass(PlanDeriver, null, [{
    key: "nonClubPlans",
    value: function nonClubPlans(plans) {
      return plans.filter(function (plan) {
        return CLUB_CLASSES_NUMBERS.indexOf(plan.reservations_per_cycle) === -1;
      });
    }
  }, {
    key: "augmentCurrentPlan",
    value: function augmentCurrentPlan(plan) {
      return _objectSpread({}, plan, {
        current: true
      });
    }
  }, {
    key: "comembershipDetails",
    value: function comembershipDetails() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        termsLink: deepExtract('display_metadata.additional_terms.link', plan, null),
        termsTitle: deepExtract('display_metadata.additional_terms.title', plan, null),
        banner: deepExtract('display_metadata.banner', plan, null),
        cardDetail: deepExtract('display_metadata.card_detail', plan, null)
      };
    }
  }, {
    key: "isUpgrade",
    value: function isUpgrade(oldPlan, newPlan) {
      return oldPlan.price < newPlan.price;
    }
  }, {
    key: "cheapestPlan",
    value: function cheapestPlan(plans) {
      return plans.reduce(function (cheapest, plan) {
        if (!cheapest || plan.price < cheapest.price) {
          return plan;
        }

        return cheapest;
      }, null);
    }
  }, {
    key: "isComembershipPlan",
    value: function isComembershipPlan() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var type = plan.type;
      return !!type && type === COMEMBERSHIP;
    }
  }, {
    key: "filterPlans",
    value: function filterPlans(plans) {
      var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!plans || !rules || !rules.length) {
        return plans;
      }

      return plans.filter(function (plan) {
        return rules.some(function (expr) {
          return !new RegExp(expr).test(plan.plan_code);
        });
      });
    }
  }, {
    key: "isLiveNoHardware",
    value: function isLiveNoHardware(planMode) {
      return planMode.substr(-12) === '_no_hardware';
    }
  }, {
    key: "isCostcoPlan",
    value: function isCostcoPlan(plan) {
      if (!plan || !plan.id) {
        return false;
      }

      return COSTCO_PLAN_IDS.includes(plan.id);
    }
  }, {
    key: "isAllowPrepaidCards",
    value: function isAllowPrepaidCards() {
      var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !!plan && ALLOW_PREPAID_CARDS_PLANS.indexOf(plan.plan_code) > -1;
    }
  }, {
    key: "isCorporateJustworks",
    value: function isCorporateJustworks(planCode) {
      return planCode && CORPORATE_JUSTWORKS_REGEX.test(planCode);
    }
  }, {
    key: "isCorporatePlan",
    value: function isCorporatePlan(plan) {
      var planCode = deepExtract('plan_code', plan, '');
      return CORPORATE_PLAN_REGEX.test(planCode) || CORPORATE_JUSTWORKS_REGEX.test(planCode);
    }
  }]);

  return PlanDeriver;
}();

export { PlanDeriver as default };